import W from '@wamms/tinylib'

export default {
	init() {
		// hero video
		let hero	  = W.sel( '.hero-video video' )
        // let hero	  = W.sel( '.hero-video .hero-img' )
		let hero_fade = 0.5

		// scrollers
		let scroller	   = W.sel( '.scroller' )
		let scroller_speed = 1.0

		// listen to scrolling
		W.listen( window, 1, 'scroll', () => {
			// adjust video opacity
			let h2 = innerHeight * hero_fade
			let op = 1 - Math.min( 1, scrollY /*pageYOffset*/ / h2 )
			hero[0].style.opacity = op

			// move scrollers
			for ( let scr of scroller ) {
				// speed based on window height: 1.5 * innerHeight / 1500
				// speed based on window width:  1.5 * innerWidth / 1700
				// speed based on parent height: 1.5 * scr.parentNode.scrollHeight / 1300
				let speed = scroller_speed * scr.parentNode.scrollHeight / innerHeight
				let bb    = scr.getBoundingClientRect()
				if ( bb.top < innerHeight && bb.bottom >= 0 ) {
					W.trans( scr, ( innerHeight - bb.top ) * speed * ( scr.dataset.dir === 'left' ? 1 : -1 ), 0, 'px' )
				}
			}
		} )
	}
}